import { createWebHistory, createRouter } from 'vue-router'

import DashboardView from '../components/DashboardView.vue'
import LegsView from '../components/legs/LegsView.vue'
import CheckridesView from '../components/checkrides/CheckridesView.vue'
import SettingsView from '../components/SettingsView.vue'

import LegsSettingsView from '../components/settings/LegsSettingsView.vue'
import EmailSettingsView from '../components/settings/EmailSettingsView.vue'
import UserSettingsView from '../components/settings/UserSettingsView.vue'

import LoginForm from '../components/LoginForm.vue'
import PendingApprovalView from '../components/PendingApprovalView.vue'

const routes = [
    {
        path: '/',
        component: DashboardView,
        children: [
            {
                path: '',
                name: 'Legs Report',
                component: LegsView
            },
            {
                path: 'checkrides',
                name: 'Checkrides',
                component: CheckridesView
            },
            {
                path: 'settings',
                name: 'Settings',
                redirect: '/settings/legs',
                component: SettingsView,
                children: [
                    {
                        path: 'legs',
                        name: 'Legs Settings',
                        component: LegsSettingsView
                    },
                    {
                        path: 'emails',
                        name: 'Email Settings',
                        component: EmailSettingsView
                    },
                    {
                        path: 'users',
                        name: 'User Settings',
                        component: UserSettingsView
                    }
                ]
            }
        ]
    },
    {
        path: '/login',
        component: LoginForm,
        name: 'Login'
    },
    {
        path: '/pending',
        component: PendingApprovalView,
        name: 'Pending Approval'
    },
    {
        path: '/auth/success',
        name: 'OAuth Success',
        component: () => import('../components/OAuthCallback.vue'),
        props: { success: true }
    },
    {
        path: '/auth/failure',
        name: 'OAuth Failure', 
        component: () => import('../components/OAuthCallback.vue'),
        props: { success: false }
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router